var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V21.5H21V0.5H0ZM17.4375 5.51562L16.3125 6.59375C16.2188 6.64062 16.1719 6.78125 16.1719 6.875V14.8438C16.1719 14.9375 16.2188 15.0781 16.3125 15.125L17.3906 16.2031V16.4375H11.8594V16.2031L13.0312 15.125C13.125 14.9844 13.125 14.9844 13.125 14.7969V8.375L9.9375 16.4375H9.51562L5.85938 8.375V13.7656C5.8125 14 5.90625 14.2344 6.04688 14.375L7.54688 16.2031V16.4375H3.32812V16.2031L4.78125 14.375C4.96875 14.2344 5.01562 14 4.96875 13.7656V7.53125C5.01562 7.39062 4.92188 7.20312 4.82812 7.0625L3.51562 5.51562V5.23438H7.59375L10.7344 12.1719L13.5469 5.28125H17.4375V5.51562Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.36015813adb9d4020838e94633ceca8a.svg";
export { ForwardRef as ReactComponent };